// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_style_checkbox__rYjrx","rotate":"Checkbox_style_rotate__wB0bO"};